import { Box, Typography, Grid, Button } from '@mui/material';
import { useAuth } from '@/hooks/useAuth';
import { useTeacherAssignments } from '@/hooks/useTeacherAssignments';
import { TeacherAssignmentCard } from '@/features/teachers/components/TeacherAssignmentCard';
import { Loader } from '@/components/feedback/Loader';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '@/router/paths';

export function MyClassesPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { assignments, loading } = useTeacherAssignments(user?.teacherId);

  if (loading) return <Loader />;

  return (
    <Box>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            My Classes
          </Typography>
          <Typography color="text.secondary">
            Classes and subjects you are currently assigned to teach
          </Typography>
        </Box>
        <Button variant="contained" onClick={() => navigate(PATHS.TEACHER_ATTENDANCE)}>
          Mark Attendance
        </Button>
      </Box>

      {assignments?.length === 0 ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <Typography color="text.secondary">No classes assigned to you.</Typography>
        </Box>
      ) : (
        <Grid container spacing={3}>
          {assignments?.map((assignment) => (
            <Grid size={{ xs: 12, md: 6, lg: 4 }} key={assignment.id}>
              <TeacherAssignmentCard assignment={assignment} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
